
const getCurrentUser = (vue) => {
    if (vue && vue.$store && vue.$store.state && vue.$store.state.users && vue.$store.state.users.current)
        return vue.$store.state.users.current;

    return null
}

export {
    getCurrentUser
}


// WEBPACK FOOTER //
// ./src/helpers/store/index.js